<template>
  <v-container class="pa-4">
    <v-row no-gutters>
      <v-col cols="12">
        <v-btn
          fab
          x-small
          :color="site.color"
          @click="redirectTo()"
          dark
          class="mb-4"
        >
          <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="d-flex justify-center">
        <div style="max-height: 240px">
          <img
            :src="pathImage"
            style="
              max-width: 100%;
              max-height: 240px;
              width: auto;
              height: auto;
              border-radius: 10px;
              object-fit: contain;
              display: block;
              margin: 0 auto;
            "
            @error="onImageError($event, missionDetail, 'image_url')"
          />
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-3">
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="12">
            <p class="text-subtitle-1 text--primary mx-0 text-center mb-0">
              {{ missionDetail.name }}
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-3" style="margin-bottom: 160px">
      <v-col cols="12" class="px-0">
        <v-row no-gutters class="mx-5">
          <v-spacer></v-spacer>
          <v-btn v-if="showCommentField" @click="hideSuveyForm = true" icon
            ><v-icon>mdi-content-save-edit-outline</v-icon></v-btn
          >
        </v-row>

        <v-row class="my-5 justify-center" no-gutters>
          <v-col cols="10">
            <v-row no-gutters class="justify-center">
              <v-col cols="6" class="pr-2">
                <v-btn
                  block
                  rounded
                  :color="site.color"
                  @click="dialogScan = true"
                  :disabled="code.length >= 5"
                  class="d-flex align-center"
                  style="color: white"
                >
                  <v-icon small class="mr-2">mdi-qrcode-scan</v-icon
                  >{{ $t("scanCode") }}
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  block
                  rounded
                  :color="site.color"
                  dark
                  @click="dialogImage = true"
                  class="d-flex align-center"
                  outlined
                >
                  <v-icon small class="mr-2">mdi-file-image-outline</v-icon>
                  {{ $t("sampleImage") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row no-gutters class="justify-center ma-0">
          <v-col cols="10" class="pa-0">
            <v-form ref="form">
              <v-text-field
                :label="$t('codeNo', { no: 1 })"
                outlined
                v-model="code[0]"
                dense
              ></v-text-field>
              <v-text-field
                :label="$t('codeNo', { no: 2 })"
                outlined
                v-model="code[1]"
                dense
              ></v-text-field>
              <v-text-field
                :label="$t('codeNo', { no: 3 })"
                outlined
                v-model="code[2]"
                dense
              ></v-text-field>
              <v-text-field
                :label="$t('codeNo', { no: 4 })"
                outlined
                v-model="code[3]"
                dense
              ></v-text-field>
              <v-text-field
                :label="$t('codeNo', { no: 5 })"
                outlined
                v-model="code[4]"
                dense
              ></v-text-field>
            </v-form>
          </v-col>
        </v-row>

        <v-dialog v-model="dialogImage" persistent max-width="290">
          <v-card>
            <v-card-title class="text-center"></v-card-title>
            <v-card-text>
              <v-img
                contain
                max-height="160"
                :src="missionDetail.image_lucky"
              ></v-img>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                text
                rounded
                :color="site.color"
                dark
                @click="dialogImage = false"
                class="pt-0"
                >{{ $t("close") }}</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>

      <v-col cols="12" v-if="showCommentField">
        <v-textarea
          :label="$t('textDescription')"
          v-model="description"
          solo
        ></v-textarea>
      </v-col>
    </v-row>

    <v-footer fixed padless color="white">
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <v-row class="pt-4" justify="center">
              <v-col cols="11" md="3" class="py-0 pb-4">
                <v-btn
                  block
                  class="pa-5 rounded-lg white--text"
                  :color="site.color"
                  @click="confirmUpload()"
                  >{{ $t("activityUpload") }}</v-btn
                >
              </v-col>
              <v-col cols="11" md="3" class="py-0 pb-4">
                <v-btn
                  block
                  class="pa-5 rounded-lg"
                  :color="site.color"
                  outlined
                  @click="redirectTo()"
                >
                  {{ $t("back") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>

    <v-dialog v-model="dialogCode" persistent max-width="390">
      <v-card>
        <v-card-title
          class="text-h5 justify-center text-center d-flex flex-column align-center"
          :style="{ color: site.color }"
        >
          <v-icon :color="site.color" size="60" class="my-3"
            >mdi-check-circle-outline</v-icon
          >
          {{ $t("thankYouForParticipatingActivity") }}
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">{{ $t("code") }}</th>
                  <th class="text-center">{{ $t("status") }}</th>
                  <th class="text-center">{{ $t("coin") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in showCode" :key="item.code">
                  <td class="text-center">{{ item.code }}</td>
                  <td class="text-center">
                    <v-chip :color="getStatusColor(item.status)" dark>
                      {{ item.status_label }}
                    </v-chip>
                  </td>
                  <td class="text-center">{{ item.point }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="site.color" outlined dark @click="resetCode()">
            {{ $t("resendCode") }}
          </v-btn>
          <v-btn :color="site.color" @click="closeDialogCode()" dark>
            {{ $t("confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogScan
      :dialogScan="dialogScan"
      @closeDialogScan="closeScan"
      :confirmExternal="true"
      @scanText="handleScanQR"
    />
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import moment from "moment";
import { mapState } from "vuex";
import DialogScan from "@/components/activity/dialogScan.vue";

export default {
  inject: ["isAppLoading"],
  data: () => ({
    missionDetail: {
      id: null,
      name: null,
      mission_status: null,
      schema_survey: null,
      image_url: null,
      image_path: null,
      image_upload: null,
      description: null,
    },
    dialogScan: false,
    drawer: false,
    group: null,
    dataItem: [],
    image_preview: null,
    image: null,
    valid: true,
    employee_mission_id: "",
    description: "",
    componentKey: 0,
    displayType: false,
    shareDialog: false,
    currentUrl: "",
    survey: null,
    hideSuveyForm: true,
    dialogImage: false,
    show: true,
    code: [],
    codeSubmit: [],
    showCode: [],
    dialogCode: false,
  }),
  components: { DialogScan },

  async created() {
    await this.getMyMissionById(this.$route.params.id);
    this.fetchImage();
    this.currentUrl = window.location.href;
  },

  methods: {
    redirectTo() {
      this.$router.push({
        name: "my-mission-detail",
        params: {
          id: this.$route.params.id,
        },
      });
    },
    onImageError(event, item, key) {
      if (item && item[key]) {
        item[key] = "";
      } else {
        event.target.style.display = "none";
      }
    },
    resetCode() {
      this.code = [];
      this.codeSubmit = [];
      this.showCode = [];
      this.dialogCode = false;
    },
    getStatusColor(param) {
      if (param == "สำเร็จ") {
        return "green";
      } else if (param == "รหัสซ้ำ") {
        return "orange";
      } else {
        return "red";
      }
    },
    closeScan() {
      this.dialogScan = false;
    },
    handleScanQR(param) {
      this.dialogScan = false;
      this.code.push(param);
    },
    closeDialogCode() {
      this.dialogCode = false;
      this.showCode = [];
      this.$router.push({
        name: "mission",
      });
    },
    async getMyMissionById(id) {
      try {
        const myMission = await Axios.get("mission/getMyMission", {
          params: {
            employee_mission_id: id,
            view_in_period_remind_date: false,
            view_limit_reached: false,
          },
        });
        if (myMission.data?.status == "success") {
          this.missionDetail = myMission.data.data;
          if (this.missionDetail.not_allowed) {
            this.$swal
              .fire({
                icon: "error",
                title: this.$t("messageActivityErrorReJoin"),
                showConfirmButton: false,
                timer: 4000,
              })
              .then(() => {
                this.$router.push({
                  name: "mission",
                });
              });
          }
        }
      } catch (err) {
        console.log("getMissionById", err);
        this.$swal
          .fire({
            icon: "error",
            title: err?.response?.data?.message,
            showConfirmButton: false,
            timer: 4000,
          })
          .then(() => {
            this.$router.push({
              name: "mission",
            });
          });
      }
    },
    fetchImage() {
      let typeVideo = ["mp4", "mov"];
      let typeImage = ["jpg", "png"];
      this.image_preview = this.missionDetail.image_upload;
      this.description = this.missionDetail.description;
      if (!this.image_preview) {
        return;
      }
      this.hideSuveyForm = false;
      let typeFile = this.image_preview
        .split(/[#?]/)[0]
        .split(".")
        .pop()
        .trim();
      if (typeVideo.some((item) => item == typeFile)) {
        this.displayType = true;
      }
      if (typeImage.some((item) => item == typeFile)) {
        this.displayType = false;
      }
      setTimeout(() => {
        this.componentKey++;
      }, 2000);
    },
    confirmUpload() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.code.length < 1) {
        this.$swal.fire(
          this.$t("error.title"),
          this.$t("validation.minCode"),
          "error"
        );
        return;
      }
      this.code.forEach((item) => {
        if (item) {
          this.codeSubmit.push(item);
        }
      });

      this.isAppLoading(true);
      Axios.post(
        "/mission/confirmMissionLuckyDraw",
        {
          code: this.codeSubmit,
          employee_mission_id: this.$route.params.id,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
        .then((res) => {
          if (res.data.status == "success") {
            this.showCode = res.data.data;
            this.dialogCode = true;
          } else {
            this.$swal.fire(this.$t("error.title"), res.data.error, "error");
          }
        })
        .then(() => {
          this.codeSubmit = [];
        })
        .catch((err) => {
          this.codeSubmit = [];
          console.log("err :>> ", err);
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),

    normalRules() {
      return [(v) => !!v || this.$t("validation.required")];
    },

    showCommentField() {
      return this.missionDetail.mission_status == "waiting" ||
        this.missionDetail.mission_status == "reject"
        ? true
        : false;
    },
    pathImage() {
      return this.missionDetail.image_path || this.missionDetail.image_url;
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YY");
    },
  },
};
</script>

<style>
.plyr--stopped.plyr__poster-enabled .plyr__poster {
  opacity: 0;
}
.sv-components-column .sd-action-bar #sv-nav-complete {
  display: none;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
  padding-bottom: 50px;
}
.sd-element__title span {
  color: black;
}
.sd-item__control-label {
  color: black;
}
</style>
